export default __webpack_public_path__ + "static/national-yards-desktop-ea3864ad52d5de39122aa5e3dfdad0c4.svg";